module.exports = __webpack_public_path__ + "/login_ui/img/logo-green-848983f00de09c3bcb0de18c9f28ccd8.svg";